import * as Yup from "yup";

export function initialValues(student){
  const rawDepartament = student?.User?.departament;
  const rawProvince = student?.User?.province;
  const rawDistrict = student?.User?.district;

  const departamentCode = rawDepartament
    ? String(rawDepartament).length === 6
      ? String(rawDepartament)
      : `${String(rawDepartament).padStart(2, "0")}0000`
    : "130000";

  const provinceCode = rawProvince
    ? String(rawProvince).length === 6
      ? String(rawProvince)
      : `${departamentCode.slice(0, 2)}${String(rawProvince).padStart(2, "0")}00`
    : "130100";

  const districtCode = rawDistrict
    ? String(rawDistrict).length === 6
      ? String(rawDistrict)
      : `${provinceCode.slice(0, 4)}${String(rawDistrict).padStart(2, "0")}`
    : "130114";

  return {
    avatar: student?.User?.avatar || "",
    fileAvatar: null,
    firstname: student?.User?.firstname || "",
    lastname: student?.User?.lastname || "",
    secondLastname: student?.User?.secondLastname || "",
    email: student?.User?.email || "",
    dni: student?.User?.dni || "",
    phone: student?.User?.phone || "",
    phone2: student?.User?.phone2 || "",
    gender: student?.User?.gender || "",
    birthDate: student?.User?.birthDate || "",
    departament: departamentCode,
    province: provinceCode,
    district: districtCode,
    address: student?.User?.address || "",
    dni_tutor: student?.dni_tutor || "",
    name_tutor: student?.name_tutor || "",
    familyRelationship: student?.familyRelationship || null,
    gradeId: student?.gradeId || "",
    paymentCategoryId: student?.paymentCategoryId || "",
  };
}

export function validationSchema() {
  return Yup.object({
    firstname: Yup.string().required("El nombre es obligatorio"),
    lastname: Yup.string().required("El apellido paterno es obligatorio"),
    secondLastname: Yup.string().required("El apellido materno es obligatorio"),
    email: Yup.string()
      .email("El correo no es válido")
      .required("El correo es obligatorio"),
    dni: Yup.number()
      .typeError("El DNI debe ser numérico")
      .nullable(),
    phone: Yup.number()
      .typeError("El teléfono debe ser numérico")
      .nullable(),
    phone2: Yup.number().typeError("El teléfono debe ser numérico").nullable(),
    gender: Yup.string().required("El género es obligatorio"),
    birthDate: Yup.string().nullable(),
    departament: Yup.string().required("El departamento es obligatorio"),
    district: Yup.string().required("El distrito es obligatorio"),
    province: Yup.string().required("La provincia es obligatoria"),
    address: Yup.string().nullable(),
    name_tutor: Yup.string().required("El nombre del tutor es obligatorio"),
    familyRelationship: Yup.string().nullable().required("La relación familiar con el tutor es obligatoria"),
    gradeId: Yup.string().required("El grado es obligatorio"),
    paymentCategoryId: Yup.string().required(
      "La categoría de pago es obligatoria"
    ),
  });
}
